<template lang="pug">
 el-main(v-loading="processing")
  quiz-info-view(
  @onProcessing="(flag) => processing = flag")
  question-list(
    :quizData="$store.state.quizData"
    @onProcessing="(flag) => processing = flag")

</template>

<script>
import QuizInfoView from '@/components/student/QuizInfoView'
import QuestionList from '@/components/student/Question/QuestionList'

export default {
  name: 'Quiz',

  components: {
    QuizInfoView,
    QuestionList,
  },  

  data() {
    return {
      processing: true,
    }
  },
}
</script>
